<template>
  <div id="register">
    <el-dialog
      :title="registerFormTitle"
      width="800px"
      :visible.sync="registerDialogVisible"
      :close-on-click-modal="false"
      @close="registerDialogClose"
    >
      <el-form
        ref="registerFormRef"
        :model="registerForm"
        label-position="right"
        label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="预约号数" prop="number">
              <el-input v-model="registerForm.number" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排号时段" prop="timeInterval">
              <el-input v-model="registerForm.timeInterval" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司名称" prop="corporateName">
              <el-input v-model="registerForm.corporateName" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="registerForm.name" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号码" prop="idCard">
              <el-input v-model="registerForm.idCard" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="model">
              <el-input v-model="registerForm.model" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="随行人员" prop="entourage">
              <el-input v-model="registerForm.entourage" placeholder="暂无随行人员信息" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预约时段" prop="appointment">
              <el-input v-model="registerForm.appointment" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来访事由" prop="visit">
              <el-select v-model="registerForm.visit" clearable>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              <el-input v-model="registerForm.createTime" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="事由备注" prop="reasonRemarks">
              <el-input
                v-model="registerForm.reasonRemarks"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="registerDialogVisible = false">
          取 消
        </el-button>
        <el-button type="primary" @click="registerFormSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showDialogVisible"
      :close-on-click-modal="false"
      width="440px"
      height="300px"
    >
      <el-form
        ref="contentFormRef"
        :model="newsForm"
        :rules="contentRule"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="暂停原因" prop="content">
          <el-input v-model="newsForm.content" placeholder="请输入暂停原因" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialogVisible = false">
          取 消
        </el-button>
        <el-button type="primary" @click="handleUpdateStatus()">
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-form inline size="small">
      <el-form-item label="公司名称">
        <el-input v-model="searchForm.corporateName" placeholder="请输入公司名称" clearable />
      </el-form-item>
      <el-form-item label="预约时间">
        <el-select
          v-model="searchForm.limitId"
          placeholder="请选择预约时间段"
          clearable
          filterable
        >
          <el-option
            v-for="item in timeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="searchForm.status" clearable>
          <el-option
            v-for="item in statusBox"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          查 询
        </el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport">
          导 出
        </el-button>
        <el-button type="primary" icon="el-icon-switch-button" @click="handleUpdates">
          暂 停
        </el-button>
        <el-button type="primary" icon="el-icon-back" @click="handleBack">
          返 回
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      id="xls-table"
      ref="registerTableRef"
      :data="registerPage.list"
      row-key="id"
      default-expand-all
      tooltip-effect="dark"
      :cell-style="{padding: '6px'}"
      :header-cell-style="{background: '#f8f8f9'}"
      :height="getTableHeight()"
      @row-click="handleRowClick"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="number" label="号数" />
      <el-table-column prop="timeInterval" label="排号时段" width="160px" />
      <el-table-column prop="corporateName" label="公司名称" />
      <el-table-column prop="name" label="姓名" />
      <el-table-column prop="idCard" label="身份证号" />
      <el-table-column prop="model" label="手机号码" />
      <el-table-column prop="entourage" label="随行人员" />
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column prop="visit" label="来访事由">
        <template slot-scope="scope">
          {{ visitOption(scope.row.visit) }}
        </template>
      </el-table-column>
      <el-table-column prop="reasonRemarks" label="事由备注" />
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status===2">正在进行</span>
          <span v-if="scope.row.status===4">已超时</span>
          <span v-if="scope.row.status===5">已暂停</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-plus"
            size="small"
            @click.stop="selectInfoRegister(scope.$index, scope.row)"
          >
            详情
          </el-button>
          <el-button
            type="text"
            icon="el-icon-success"
            size="small"
            :disabled="scope.row.status!==2"
            @click.stop="handleAccomplish(scope.$index, scope.row)"
          >
            完成
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :total="registerPage.total"
      :current-page="searchForm.pageNum"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @current-change="pageNumChange"
      @size-change="pageSizeChange"
    />
  </div>
</template>

<script>
import {
  deleteVisitRegistration,
  updateVisitRegistration,
  selectInfo,
  selectByDateList,
  selectByCondition,
  byExport,
  updateStatusRegistration,
  updateStatusById
} from '@/api/medicine/register'
import {
  getIdByTimeListForWeb,
  selectByIdVisitLimit
} from '@/api/medicine/visitLimit'
import moment from 'moment'

export default {
  data () {
    return {
      showDialogVisible: false,

      registerDialogVisible: false,
      registerFormTitle: '',
      value: '',
      registerForm: {
        id: '',
        number: '',
        corporateName: '',
        name: '',
        idCard: '',
        model: '',
        entourage: '',
        appointment: '',
        createTime: '',
        timeInterval: '',
        visit: '',
        reasonRemarks: ''
      },
      contentRule: {
        content: [{ required: true, message: '暂停原因不能为空', trigger: ['blur', 'change']}]
      },
      options: [{
        value: 1,
        label: '一般拜访'
      }, {
        value: 2,
        label: '紧急拜访'
      }, {
        value: 3,
        label: '产品推介'
      }, {
        value: 4,
        label: '产品售后'
      }],
      statusBox: [{
        value: 2,
        label: '正在运行'
      }, {
        value: 4,
        label: '已超时'
      }, {
        value: 5,
        label: '已暂停'
      }],
      registerPage: {
        list: [],
        total: 0
      },
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        corporateName: '',
        appointment: this.$route.params.date,
        limitId: '',
        status: 2
      },
      dateForm: {
        appointment: this.$route.params.date
      },
      timeList: [],
      newsForm: {
        idStr: '',
        content: '',
        idList: [],
        status: ''
      }
    }
  },
  created () {
    this.getDateList()
    this.getDownBox()
  },
  methods: {
    handleBack () {
      this.$router.go(-1)
    },
    handleUpdateStatus () {
      this.$refs.contentFormRef.validate(async valid=> {
        if (valid) {
          this.$confirm('确认暂停?', '提示', {
            type: 'warning'
          }).then(async () => {
            await updateStatusById(this.newsForm)
            this.getDateList()
            this.showDialogVisible = false
          })
        }
      })
    },
    handleUpdates () {
      if (this.newsForm.idStr == '') {
        this.$message.error('请勾选要暂停预约的人员信息！')
      } else {
        this.showDialogVisible = true
      }
    },
    handleSelectionChange (val) {
      this.newsForm.idList = []
      for (let i = 0; i < val.length; i++) {
        this.newsForm.idList.push(val[i].id)
      }
      this.newsForm.idStr = this.newsForm.idList.join(',')
    },
    getDownBox () {
      getIdByTimeListForWeb(this.dateForm.appointment).then(res=>{
        this.timeList = res.map(x=>{
          return {
            label: x.startTime.substr(10, 9) + '-' + x.endTime.substr(10, 9),
            value: x.id
          }
        })
      })
    },
    getDateList () {
      selectByDateList(this.dateForm).then(res=>{
        this.registerPage = res
      })
    },
    registerDialogClose () {
      this.$refs.registerFormRef.resetFields() //重置表单到初始值
    },
    registerFormSubmit () {
      if (this.registerFormTitle === '登记人员详情') {
        this.registerDialogVisible = false
        return
      }
    },
    handleRowClick (row, col, event) {
      this.$refs.registerTableRef.toggleRowExpansion(row)
    },
    handleExport () {
      //导出
      byExport(this.dateForm).then(res=>{
        let fileName = this.dateForm.appointment + '-来访登记.xlsx'
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(res)
        link.download = fileName
        link.click()
        //释放内存
        window.URL.revokeObjectURL(link.href)
      })
    },
    handleSearch () {
      selectByCondition(this.searchForm).then(res=>{
        this.registerPage = res
      })
    },
    handleAccomplish (index, row) {
      this.$confirm('确认完成了吗?', '提示', {
        type: 'warning'
      }).then(async ()=>{
        await updateStatusRegistration(row.id)
        if (this.registerPage.list.length === 1 && this.searchForm.pageNum > 1) {
          this.searchForm.pageNum--
        }
        this.registerPage = await selectByCondition(this.searchForm)
      })
    },
    selectInfoRegister (index, row) {
      this.registerFormTitle = '登记人员详情'
      this.registerDialogVisible = true
      this.selectInfoById(row.id)
    },
    selectInfoById (id) {
      selectInfo(id).then(res=>{
        console.log(res.number)
        this.registerForm.id = res.id
        this.registerForm.number = res.number
        this.registerForm.timeInterval = res.timeInterval
        this.registerForm.corporateName = res.corporateName
        this.registerForm.name = res.name
        this.registerForm.idCard = res.idCard
        this.registerForm.model = res.model
        this.registerForm.entourage = res.entourage
        this.registerForm.visit = res.visit
        this.registerForm.reasonRemarks = res.reasonRemarks
        this.registerForm.createTime = res.createTime
        selectByIdVisitLimit(res.limitId).then(ress=>{
          this.registerForm.appointment = ress.startTime.substr(10, 9) + '-' + ress.endTime.substr(10, 9)
        })
      })
    },
    pageNumChange (pageNum) {
      this.searchForm.pageNum = pageNum
      selectByCondition(this.searchForm).then(res => {
        this.registerPage = res
      })
    },
    pageSizeChange (pageSize) {
      this.searchForm.pageSize = pageSize
      this.searchForm.pageNum = 1
      selectByCondition(this.searchForm).then(res => {
        this.registerPage = res
      })
    },
    visitOption (visit) {
      if (visit === 1) {
        return '一般拜访'
      } else if (visit === 2) {
        return '紧急拜访'
      } else if (visit === 3) {
        return '产品推介'
      } else if (visit === 4) {
        return '产品售后'
      }
    }
  }
}
</script>
<style>
  #register .message{
    z-index: 3300 !important;
  }
</style>
